import { MoveRight } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input, Label, ResponsiveDialog } from 'ui';
import { getSelectedSiteCollaborateInfo } from '../../../store/siteInfoSlice';
import { getshowGodaddyUserNameModal, getUser, setOpenGodaddyGuestNameModal, setUpdateUserName } from '../../../store/userSlice';

export default function GodaddyNameModal() {
    const dispatch = useDispatch();
    const itemDetails = useSelector(getSelectedSiteCollaborateInfo)
    const showGodaddyUserNameModal = useSelector(getshowGodaddyUserNameModal);
    const userData = useSelector(getUser);
    const [godaddyGuestName, setGodaddyGuestName] = useState(itemDetails?.result?.godaddy_username || 'Guest');


    const handleSaveGodaddyGuestName = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if (!godaddyGuestName) return
        dispatch(setUpdateUserName(godaddyGuestName))
        const guestData: unknown = {
            ...userData,
            name: godaddyGuestName || 'Guest',
        }
        window.localStorage.setItem('atarimGuestUser', JSON.stringify(guestData));
        dispatch(setOpenGodaddyGuestNameModal(false))

    };
    const handleChangeGodaddyGuestName = (e: {
        target: HTMLInputElement; preventDefault: () => void;
    }) => {
        setGodaddyGuestName(e.target.value);
    };

    const handleChange = (bool: boolean) => {
        dispatch(setOpenGodaddyGuestNameModal(bool));
    };

    useEffect(() => {
        if (itemDetails?.result?.role === 'Guest') {
            setGodaddyGuestName(itemDetails?.result?.godaddy_username || 'Guest');
        }
    }, [itemDetails?.result?.role, itemDetails?.result?.godaddy_username]);

    const partnerLogo = itemDetails?.result?.setting?.whitelabel?.logo || ''

    return (
        <ResponsiveDialog open={showGodaddyUserNameModal} onOpenChange={handleChange}>
            <ResponsiveDialog.Content
                className="text-textcolor isolate m-auto my-0 max-w-[420px] border-none p-0"
                showClose={false}
                onInteractOutside={(event: { preventDefault: () => unknown; }) => event.preventDefault()}
                container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
            >
                <div className="w-[420px] text-center p-[15px_0] rounded-[18px] bg-background">
                    <ResponsiveDialog.Title
                        className="p-0"
                    >
                        <div className="flex flex-col gap-6 pb-2 pt-4">
                            <img
                                src={partnerLogo}
                                className="mb-1 inline-flex w-[150px] mx-auto max-w-full h-auto"
                                alt="Logo"
                            />
                            <span className="flex flex-col gap-1">
                                <h1 className="text-textcolor text-xl font-bold">
                                    What's Your Name?
                                </h1>
                                <p className="font-base flex justify-center self-center text-balance text-base text-[#71717a]">
                                    Please enter your name below so we know who you are when leaving your feedback
                                </p>
                            </span>
                        </div>
                    </ResponsiveDialog.Title>
                    <div className="flex flex-col gap-4 p-4 pb-0">
                        <div className="flex flex-col gap-2">
                            <Label htmlFor="email" className="flex items-start">
                                Your name
                            </Label>
                            <Input
                                value={godaddyGuestName}
                                type="text"
                                placeholder="Name"
                                onChange={handleChangeGodaddyGuestName}
                            />
                        </div>
                        <ResponsiveDialog.Close>
                            <Button
                                size="sm"
                                className="w-full text-sm"
                                rightIcon={<MoveRight size={18} />}
                                onClick={handleSaveGodaddyGuestName}
                            >
                                Leave Feedback
                            </Button>
                        </ResponsiveDialog.Close>

                    </div>
                </div>
            </ResponsiveDialog.Content>
        </ResponsiveDialog>
    );
}
